export default "__VITE_ASSET__DLKq67su__"